const YesNoEnum = {
    No: 0,
    Yes: 1
}

export default YesNoEnum